import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 320 × 320 px (1:1 方图)", -1)
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = {
  class: "text-muted",
  style: {"font-size":"12px","margin-bottom":"8px"}
}
const _hoisted_6 = { style: {"min-width":"24px","color":"#909399"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" + 添加排序条件 ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后未消费用户不可见", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.box_category,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.box_category.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.box_category.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "图片",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "https://jsonplaceholder.typicode.com/posts/",
              "show-file-list": false,
              "auto-upload": false,
              ref: "uploadRef",
              "on-change": _ctx.onChange
            }, {
              default: _withCtx(() => [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "avatar"
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_plus)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "排序" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.box_category.sorting,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.box_category.sorting) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.box_category.category_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.box_category.category_type) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{key: '一般', value: 0}, {key: '全局', value: 1}, {key: '对对碰', value: 2}], (item) => {
                  return _createVNode(_component_el_option, {
                    label: item.key,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "打乱" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.box_category.is_random,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.box_category.is_random) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "排序规则" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, " 置顶商品始终排在最前（自动处理）。打乱开启时排序规则被忽略。删除全部规则后将使用默认排序" + _toDisplayString(_ctx.box_category.category_type === 0 || _ctx.box_category.category_type === undefined ? '（价格升序 + 创建时间降序）' : '（创建时间降序）') + "。 ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortRules, (rule, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: rule._uid,
                  style: {"display":"flex","align-items":"center","gap":"8px","margin-bottom":"8px"}
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1) + ".", 1),
                  _createVNode(_component_el_select, {
                    modelValue: rule.field,
                    "onUpdate:modelValue": ($event: any) => ((rule.field) = $event),
                    placeholder: "字段",
                    style: {"width":"140px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "价格",
                        value: "price"
                      }),
                      _createVNode(_component_el_option, {
                        label: "创建时间",
                        value: "created_at"
                      }),
                      _createVNode(_component_el_option, {
                        label: "名称",
                        value: "name"
                      }),
                      _createVNode(_component_el_option, {
                        label: "ID",
                        value: "id"
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: rule.direction,
                    "onUpdate:modelValue": ($event: any) => ((rule.direction) = $event),
                    placeholder: "方向",
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "升序",
                        value: "asc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "降序",
                        value: "desc"
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_button, {
                    icon: _ctx.Top,
                    disabled: index === 0,
                    onClick: ($event: any) => (_ctx.moveSortRule(index, -1)),
                    circle: "",
                    size: "small"
                  }, null, 8, ["icon", "disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    icon: _ctx.Bottom,
                    disabled: index === _ctx.sortRules.length - 1,
                    onClick: ($event: any) => (_ctx.moveSortRule(index, 1)),
                    circle: "",
                    size: "small"
                  }, null, 8, ["icon", "disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    icon: _ctx.Delete,
                    type: "danger",
                    onClick: ($event: any) => (_ctx.removeSortRule(index)),
                    circle: "",
                    size: "small"
                  }, null, 8, ["icon", "onClick"])
                ]))
              }), 128)),
              (_ctx.sortRules.length < 5)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    plain: "",
                    size: "small",
                    onClick: _ctx.addSortRule
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "隐藏" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.box_category.is_hide,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.box_category.is_hide) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "启用" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.box_category.enabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.box_category.enabled) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}